// extracted by mini-css-extract-plugin
module.exports = {"hero":"Hero_hero__EROKH","content":"Hero_content__W+PLw","text":"Hero_text__BkIRn"};